export default __webpack_public_path__ + "static/media/yeopen_big@2x.1bb3c3cd.jpg";